/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useSimpliCity } from "cms/hooks/use-simplicity";

const useFeatureFlag = (key) => {
    const { settings } = useSimpliCity();
    const textFlag = settings[key];
    return textFlag === "true";
};

export { useFeatureFlag };
